// This is a minimal mock providing nothing more than support for setting and retrieving the current locale.
// We only use the full I18n functionality in the React components. Everywhere else we're just getting the current locale to build proper URLs, so we can build a minimal version that does just that and reduce our logged-out bundle size significantly.

const I18nMock = {
  locale: document.documentElement.lang
}

export default I18nMock
